
$('.del_text2 input').on('click change', function(e) {
   if(this.checked){
       $('.cart-checkout button').removeAttr("disabled");

   }else{
       $('.cart-checkout button').attr("disabled",'disabled');
     
   }
});
$('#cart-note').val("");
$('.cart-checkout button').click(function (e) {
  
    console.log("form submit");
    var delivery_input= $('.del_text2 input');
    var delivery_text="";
    if(delivery_input.is(':checked')){
        delivery_text ="[ "+delivery_input.val()+" ]";
    }
    var vat_input= $('.del_text input');
    var vat_text="";
    if(vat_input.is(':checked')){
        vat_text ="[ "+vat_input.val()+" ]";
    }
    var cart_note = $('#cart-note').val();
    $('#cart-note').val(cart_note+" / "+delivery_text+vat_text);
 
   
});
(function($) {
    
  var allPanels = $('.upsell_-products').hide();
    
  $('.upsell__heading').click(function() {
    allPanels.slideUp();
      if(!$(this).next().find('.upsell_-products').hasClass("active")){
           $('.upsell_-products').removeClass("active")
        $(this).next().find('.upsell_-products').addClass("active").slideDown();
      }else{
          $(this).next().find('.upsell_-products').removeClass("active");
           allPanels.slideUp();
      }
    return false;
  });

})(jQuery);
$('.upsell__qty input').val("0");
var currency_symbol = $('.upsell__main').data('currency');
$('.upsell__qty input').on('keyup',function () {
    var number =$(this).val();
    if(number == ""){
        number = 0;
    }
    var upsell = $(this).closest('.upsell__product');
    var price = upsell.data('price');
    var product_price = number * price;
    if(product_price == 0){
       upsell.find('.upsell__total_price').attr('data-itemprice',product_price).text('+'+currency_symbol+'0.00');
    }else{
       upsell.find('.upsell__total_price').attr('data-itemprice',product_price).text('+'+currency_symbol+(product_price/100));
    }

    let all_product= $(this).closest('.upsell_-products').find('.upsell__product');
    var total_price = 0;
    Array.from(all_product).forEach(function (item) {
       var item_price = parseInt(item.querySelector('.upsell__total_price').dataset.itemprice);
        total_price = total_price + item_price;
    });
    if(total_price == 0){
            $(this).closest('.upspell-item').find('.upsell__heading .upsell__price').text('+'+currency_symbol+'0.00');
    }else{
           $(this).closest('.upspell-item').find('.upsell__heading .upsell__price').text('+'+currency_symbol+(total_price/100)); 
    }

    var product_original_price = parseInt($('.p_original_price').val());
    var upsell_items_price = 0;
    var aLL_items = $('.upsell__total_price');
    aLL_items.each(function (index, price) {
        upsell_items_price = upsell_items_price + parseInt(price.getAttribute('data-itemprice'));
        
    })
   $('.price__current .money').text(currency_symbol+(upsell_items_price + product_original_price)/100);
});


$(document).on("click",".upsell__add-btn",function() {
  // $(this).hide();
  var $p_data =  $(this).closest('.upsell__product');
  var variant_id = $p_data.data('vid');
  var qty = $p_data.find('input').val();
  if(qty == 0)
  {
    $p_data.find('input').val(1);
    qty = 1;
  }

$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  "quantity": parseInt(qty),
  "id": parseInt(variant_id)
},
  dataType: 'json', 
 success: function (data) { 
window.location.replace("/cart");
 
 } 
 });

    // this.parentElement.nextElementSibling.childNodes[0].value++;
    // $(this).parent().next().find('input').keyup();
});


$(document).on("click",".upsell__qty-plues",function() {
    this.parentElement.querySelector('input').value++;
    $(this).parent().find('input').keyup();
});

$(document).on("click",".upsell__qty-minus",function() {
    if(this.parentElement.querySelector('input').value != '0'){
      this.parentElement.querySelector('input').value--;
    }
    $(this).parent().find('input').keyup();
});


// Initially hide the form field on page load
document.addEventListener('DOMContentLoaded', function() {
  const formField = document.querySelector('.cart-ordernote .form-field');
  if (formField) {
      formField.style.display = 'none';
  }
});

// Toggle the form field on button click
if (document.querySelector('.cart-ordernote-heading')) { 
document.querySelector('.cart-ordernote-heading').addEventListener('click', function() {
  const formField = document.querySelector('.cart-ordernote .form-field');
  if (formField.style.display === 'none') {
      formField.style.display = 'block';
  } else {
      formField.style.display = 'none';
  }
});
}
$(document).on('click','.collection-filters__filter-group.show__more', function (params) {
    $(this).addClass("hidden").siblings().removeClass("hidden");
})

// $(document).on("click",".site-header-menu-toggle",function() {
//   if($('html').hasClass('scroll-locked')){
//     $('html').removeClass('scroll-locked');
//     $('#site-mobile-nav').attr("data-open","false")
//     $('#site-mobile-nav .mobile-nav-panel').attr("data-animation-state","close")
//     $('#site-mobile-nav .mobile-nav-overlay').attr("data-animation-state","close")
//   }else{
//     $('html').addClass('scroll-locked')
//     $('#site-mobile-nav').attr("data-open","true")
//     $('#site-mobile-nav .mobile-nav-panel').attr("data-animation-state","open")
//     $('#site-mobile-nav .mobile-nav-overlay').attr("data-animation-state","open")
//   }
// });



